import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "reactstrap";
import Section from "../../common/Section";
import bg from "./../../../assets/img/illustrations/corner-4.png";
import ButtonIcon from "../../common/ButtonIcon";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { PreloadState } from "../../UI/preloading/PreloadState";

const Privacy = () => {
  const history = useHistory();
  const sectionRef = useRef(null);

  useEffect(() => {
    if (sectionRef.current) {
      const contentHeight = sectionRef.current.scrollHeight;
      sectionRef.current.style.height = `${contentHeight}px`;
    }
  }, []);

  const primerCampoRef = useRef(null);

  useEffect(() => {
    primerCampoRef.current.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <>
      <Section
        ref={sectionRef}
        image={bg}
        className="d-flex text-center align-items-center justify-content-center py-0"
        style={{ backgroundSize: "cover" }}
        position="center bottom"
      >
        <PreloadState>
          <Row className="min-vh-100 align-items-center row py-5 py-md-0 ">
            <Col sm={12} className="mt-3">
              <Row className="justify-content-center text-center ">
                <Col lg={12} xl={7} xxl={6} className="col-xxl-6">
                  <h5 ref={primerCampoRef} className="fs-1 fs-sm-2 fs-md-1 text-left">
                    Declaración de privacidad
                  </h5>
                  <p className="lead fs--1 text-left">
                    Esta Declaración de privacidad explica nuestras prácticas (y sus elecciones) con respecto a la recopilación, el uso y la divulgación de ciertos datos, incluida su información personal en relación con el servicio de Homelan.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Contacto</h5>
                  <p className="lead fs--1 text-left">
                    Si tiene preguntas generales sobre su cuenta o cómo ponerse en contacto con nuestro Servicio al Cliente para obtener asistencia, visite nuestro centro de ayuda online. Si tiene alguna pregunta específica respecto de esta Declaración de privacidad, o nuestro uso de su información personal, de las cookies o de otras tecnologías similares, escriba a nuestro responsable de Protección de Datos o a la Oficina de Privacidad.
                    <br />
                    <br />
                    El responsable del tratamiento de los datos de su información personal es Homelan C.A.. Tenga en cuenta que, si se comunica con nosotros para obtener ayuda, tanto por su seguridad como por la nuestra, podemos pedirle que autentique su identidad antes de atender su solicitud.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Recopilación de la información</h5>
                  <p className="lead fs--1 text-left">
                    Recibimos y almacenamos información sobre usted, incluida:
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center text-center">
                <Col lg={9} xl={7} xxl={6} className="col-xxl-6">
                  <ul>
                    <li className="lead fs--1 text-left">
                      <b>La información que usted nos proporciona:</b> Recopilamos la información que usted nos brinda, que incluye: Su nombre, email, formas de pago, número de teléfono y otros identificadores que pueda utilizar. En algunos países, solicitamos un número de identificación gubernamental para la facturación y el cumplimiento de normas impositivas.
                    </li>
                    <li className="lead fs--1 text-left">
                      <b>La información que recopilamos automáticamente:</b> Recopilamos información con relación a usted, el uso de nuestro servicio, sus interacciones con nosotros y nuestra publicidad, además de aquella información relacionada con su red, los dispositivos de red y su computadora.
                    </li>
                    <li className="lead fs--1 text-left">
                      <b>Información de socios:</b> Recopilamos información a través de otras empresas con las que usted tiene una relación (“Socios”). Entre estos Socios, podrían incluirse su proveedor de servicios de administración u otros.
                    </li>
                    <li className="lead fs--1 text-left">
                      <b>La información que obtenemos de otras fuentes:</b> También obtenemos información de otras fuentes. Protegemos esta información según las prácticas descritas en esta Declaración de privacidad.
                    </li>
                  </ul>
                </Col>
              </Row>
              <Row className="justify-content-center text-center ">
                <Col lg={12} xl={7} xxl={6} className="col-xxl-6">
                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Uso de la información</h5>
                  <p className="lead fs--1 text-left">
                    Usamos la información recopilada para proporcionar, analizar, administrar, mejorar y personalizar nuestros services e iniciativas de marketing, para administrar las recomendaciones de miembros, para procesar su registro, solicitudes y pagos; y para comunicarnos con usted sobre este y otros temas.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Transferencia de la información</h5>
                  <p className="lead fs--1 text-left">
                    Transferimos su información para determinados propósitos y a terceros, de la siguiente manera: La familia de empresas de Homelan, Proveedores de servicios, Socios y en caso de transferencias de negocios.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Acceso a la cuenta y los perfiles</h5>
                  <p className="lead fs--1 text-left">
                    <b>Función “Recordarme”:</b> Para facilitar el acceso a su cuenta, puede usar la función “Recordarme en este dispositivo”.
                    <br />
                    <br />
                    <b>Eliminar el acceso a su cuenta de Homelan:</b> Para eliminar el acceso a su cuenta de Homelan desde sus dispositivos, visite la sección “Cuenta” de nuestro sitio web.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Sus opciones</h5>
                  <p className="lead fs--1 text-left">
                    <b>Email y mensajes de texto.</b> Si ya no desea recibir ciertas comunicaciones nuestras, simplemente acceda a las opciones de configuración de comunicaciones en la sección “Cuenta”.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Seguridad</h5>
                  <p className="lead fs--1 text-left">
                    Contamos con medidas administrativas, logísticas, físicas y de gestión razonables para proteger su información personal contra pérdidas, robos y acceso no autorizado.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Cookies y publicidad de internet</h5>
                  <p className="lead fs--1 text-left">
                    Nosotros y nuestros Proveedores de servicios utilizamos cookies y otras tecnologías (como contadores de visitas a la web), además de identificadores de dispositivos reconfigurables, por diferentes razones.
                  </p>

                  <h5 className="fs-1 fs-sm-2 fs-md-1 text-left mt-3">Eliminación de tu cuenta y tus datos</h5>
                  <p className="lead fs--1 text-left">
                    Puedes solicitar la eliminación de tu cuenta y de la información asociada en cualquier momento, tanto desde la aplicación móvil como desde la web, completando el{" "}
                    <Link to="/account-deletion">formulario de eliminación de cuenta</Link>. Recibirás un correo para confirmar la solicitud y nuestro equipo la procesará en un plazo máximo de 30 días hábiles.
                  </p>

                  <p className="lead fs--1 text-left mt-4">
                    <b>Última actualización:</b> 8 de noviembre de 2021
                  </p>
                </Col>
              </Row>

              <Row className="mt-4 mb-4">
                <Col sm={12} className="px-5">
                  <Row>
                    <Col sm={12} className="text-center">
                      <ButtonIcon
                        color="falcon-default"
                        className="px-5 mr-2"
                        icon={faUndo}
                        onClick={() => history.goBack()}
                        iconAlign="right"
                        transform="down-1 shrink-4"
                        size="sm"
                      >
                        Volver
                      </ButtonIcon>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </PreloadState>
      </Section>
    </>
  );
};

export default Privacy;
